import { useState } from 'react';

import styles from './navbar.module.css';

export default function CustomSearchBar() {
  const [query, setQuery] = useState('');
  // apparently we don't use this? (2/3/2026)
  // const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();

    if (query.trim()) {
      const q = encodeURIComponent(query.trim());
      const fullUrl = `/search?q=${q}#gsc.tab=0&gsc.q=${q}&gsc.page=1`;

      // Use native redirect to force hash on Google's ProSE
      // allows us to make multiple searches without returning to home page
      window.location.href = fullUrl;
    }
  };

  return (
    <form onSubmit={handleSearch} className={styles.searchForm}>
      <input
        type="text"
        className={styles.searchBar}
        placeholder="Search NBA Finals articles or ask a question..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />
      <button type="submit" className={styles.searchButton}>Search</button>
    </form>
  );
}
